import { Component, Input, ViewChild } from '@angular/core';
import {
  MatAccordion,
  MatExpansionModule,
  MatExpansionPanel,
} from '@angular/material/expansion';
import { NgxLoadingModule } from 'ngx-loading';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-firm-benchmarking',
  templateUrl: './firm-benchmarking.component.html',
  styleUrls: ['./firm-benchmarking.component.scss'],
  imports: [MatAccordion, MatExpansionModule, NgxLoadingModule, MatTooltip],
  standalone: true,
})
export class FirmBenchmarkingComponent {
  @Input() benchmarkData;
  @Input() loading;
  @Input() label;
  @Input() description;
  @ViewChild('benchmarkAccordion', { static: false })
  public benchmarkAccordion: MatExpansionPanel;

  constructor() {}

  tableHeaders(dataset) {
    return Object.keys(dataset[0]);
  }
}
